import { FoxRequestHeader } from "../domain/fox-request-header";

export const FoxGetReservationRequest = function (data) {
    if(!data)data={};
    this.requestHeader = new FoxRequestHeader({requestType:"GET"});
    this.customerInfo=  data.customerInfo || null;
    this.reservationCode=  data.reservationCode || null;
};